import { ButtonUi, Card, FormUi } from "../../ui";
import { useDispatch, useSelector } from "react-redux";
import { Form, Space, Tooltip } from "antd";
import {
  DateFormats,
  TipoButtonConstants,
} from "../../../types/typesConstants";
import dayjs from "dayjs";
import { proveedorStartAdd, proveedorStartUpdate } from "../../../actions";
import { ProveedorForm } from "./ProveedorForm";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  persona:
    {
      ...data?.persona,
      fechanacimiento: dayjs(data?.persona?.fechanacimiento),
      image: data?.persona?.image || null,
    } || null,
  state: data?.state || true,
});
export const ProveedorScreen = ({ handleCloseForm }) => {
  const dispatch = useDispatch();
  const { activeProveedor } = useSelector((state) => state.proveedor);
  const [form] = Form.useForm();
  const handleSubmit = async (values) => {
    values = {
      ...values,
      persona: {
        ...values.persona,
        fechanacimiento: dayjs(values.fechanacimiento).format(
          DateFormats.backend
        ),
      },
    };
    if (activeProveedor) dispatch(proveedorStartUpdate(values));
    else dispatch(proveedorStartAdd(values));
    handleCloseForm();
  };
  return (
    <FormUi
      form={form}
      autoComplete="off"
      key="FormEmpleado"
      layout="vertical"
      handleSubmit={handleSubmit}
      initialValues={initialValues(activeProveedor)}
    >
      <Card
        title={
          <>
            Proveedor
            {activeProveedor ? (
              <small> Editar</small>
            ) : (
              <small> Registrar</small>
            )}
          </>
        }
        size="small"
        extra={
          <Space wrap>
            <ButtonUi typeUi={TipoButtonConstants.Guardar} htmlType="submit">
              Guardar
            </ButtonUi>
            <Tooltip title="Salir">
              <ButtonUi
                typeUi={TipoButtonConstants.Cancelar}
                onClick={handleCloseForm}
              />
            </Tooltip>
          </Space>
        }
      >
        <ProveedorForm />
      </Card>
    </FormUi>
  );
};
